import React from "react";
import "./MayaBrandMark.css";

/**
 * Business OS logo for headers and auth screens.
 * @param {"header"|"login"|"auth"} [variant="header"]
 * @param {string} [tagline] unused — kept for existing call sites
 */
const MayaBrandMark = ({ variant = "header", className = "" }) => {
  return (
    <div
      className={`maya-brand maya-brand--${variant} ${className}`.trim()}
      aria-label="Business OS"
    >
      <img
        src={`${process.env.PUBLIC_URL || ""}/business-os-logo.png`}
        alt="Business OS"
        className="maya-brand__logo"
      />
    </div>
  );
};

export default MayaBrandMark;
